import { Form, PrivacyFormStore, ReconsiderationsFormStore } from './formStore.type';

const updateStatus = (store: Form, updates: Partial<Form['status']>) => ({
  ...store,
  status: {
    ...store.status,
    ...updates,
  },
});

const updatePrivacyForm = (store: Form, updates: PrivacyFormStore) => ({
  ...store,
  data: {
    ...store.data,
    privacy: updates,
  },
});

const updateReconsiderationsForm = (store: Form, updates: ReconsiderationsFormStore) => ({
  ...store,
  data: {
    ...store.data,
    reconsiderations: updates,
  },
});

export const validateCostsAndConditionsForm = (store: Form, validate: boolean) => {
  return updateStatus(store, { costsAndConditions: validate });
};

export const validateContractualForm = (store: Form, validate: boolean) => {
  return updateStatus(store, { contractual: validate });
};

export const validateReconsiderationsForm = (store: Form, validate: boolean) => {
  return updateStatus(store, { reconsiderations: validate });
};

export const validateLinksForm = (store: Form, validate: boolean) => {
  return updateStatus(store, { allLinksClicked: validate });
};

export const setPrivacyFormValues = (store: Form, values: PrivacyFormStore) => {
  return updatePrivacyForm(store, values);
};

export const setReconsiderationsFormValue = (store: Form, value: ReconsiderationsFormStore) => {
  return updateReconsiderationsForm(store, value);
};
